export const TRANSLATION_STATUS = {
  pending: 'pending',
  translated: 'translated',
};

export const TRANSLATION_TOPIC_CHANNEL = {
  done: 'translation-done',
  initiated: 'translation-initiated',
};
